export default __webpack_public_path__ + "static/media/bg-secure.6f35e60a.png";